import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { communicationFilters, communicationTypeOptions } from "../../lists/communicationFilters";

export const campaignPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "campaign",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 9, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "tables",
              id: "tables-communications",
              tabs: [
                {
                  id: "tab-communications",
                  label: "Email Communications",
                  // Read with the campaign by GetPageData; saved campaigns only.
                  entityName: "g4c_communication",
                  filters: communicationFilters,
                  flush: true,
                  sort: { primary: { key: "g4c_startdate", dir: "desc" } },
                  showWhenNew: true,
                  newRecordMessage:
                    "Save the campaign to see the communications that belong to it.",
                  emptyMessage: "No communications belong to this campaign.",
                  columns: [
                    {
                      key: "name",
                      label: "Name",
                      width: 300,
                      sortable: true,
                      link: { to: "/email-communication", idKey: "id", newTab: "button" },
                    },
                    {
                      key: "statuscode",
                      label: "Status",
                      width: 150,
                      sortable: true,
                      display: "component",
                      componentKey: "communicationStatus",
                    },
                    {
                      key: "g4c_communicationtype",
                      label: "Type",
                      width: 150,
                      sortable: true,
                      display: "picklist",
                      options: communicationTypeOptions,
                    },
                    {
                      key: "g4c_audienceidName",
                      label: "Audience",
                      width: 200,
                      sortable: true,
                      link: { to: "/audience", idKey: "g4c_audienceid", newTab: "button" },
                    },
                    {
                      key: "g4c_startdate",
                      label: "Start Date",
                      width: 200,
                      sortable: true,
                      display: "datetime",
                    },
                    {
                      key: "g4c_enddate",
                      label: "End Date",
                      width: 200,
                      sortable: true,
                      display: "datetime",
                    },
                    { key: "g4c_sid", label: "SID", width: 100, sortable: true },
                    {
                      key: "g4c_usedynamiccontent",
                      label: "Use Dynamic Content",
                      width: 200,
                      sortable: true,
                      display: "yesno",
                    },
                    {
                      key: "createdon",
                      label: "Created On",
                      width: 200,
                      sortable: true,
                      display: "datetime",
                    },
                    {
                      key: "modifiedon",
                      label: "Modified On",
                      width: 200,
                      sortable: true,
                      display: "datetime",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 3, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-campaign",
              title: "Reporting Campaign",
              fields: [
                {
                  id: "field-name",
                  type: "text",
                  name: "name",
                  label: "Name",
                  required: true,
                  isNameField: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
